import axios from "axios";

export function getSubCategories(id) {
    let url = process.env.REACT_APP_BASE_URL + `api/v1/subcategories/subcategory/${id}`;
    const bannerToken =localStorage.getItem("rfis");
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }

  
  export function getSubCategory(id) {
    let url = process.env.REACT_APP_BASE_URL + `api/v1/subcategories/${id}`;
    const bannerToken =localStorage.getItem("rfis");
    return axios.get(url, {
      headers: {
        rf_token_header123_k: bannerToken,
        "Content-Type": "application/json",
      },
    });
  }
export function addSubCategory(data){
    const bannerToken =localStorage.getItem("rfis");
    return axios.post(process.env.REACT_APP_BASE_URL + `api/v1/subcategories`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        
        }
    });
}
export function updateSubCategory(id,data){
    const bannerToken =localStorage.getItem("rfis");
    return axios.put(process.env.REACT_APP_BASE_URL + `api/v1/subcategories/${id}`, data, {
        headers: {
            'rf_token_header123_k': bannerToken,
        
        }
    });
}

export function deleteSubCategory(id) {
    const token =localStorage.getItem("rfis");
        return axios.delete(
          process.env.REACT_APP_BASE_URL + `api/v1/subcategories/${id}`,
          {
            headers: {
              rf_token_header123_k: token,
              "Content-Type": "application/json",
            },
          }
        ); 
      }
      
